import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';

@Component({
  selector: 'app-modal-noyes',
  templateUrl: './modal-noyes.component.html',
  styleUrls: ['./modal-noyes.component.scss']
})
export class ModalNoyesComponent implements OnInit {
  icon: any;
  labelTitile: string;
  textDescription: any;
  textIndication: any;
  status: any;
  button = false;
  onAdd = new EventEmitter();
  constructor(
    public dialogRef: MatDialogRef<ModalNoyesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataMessageModel) {
  }

  ngOnInit() {
    this.icon = this.data.icon;
    this.labelTitile = this.data.labelTitile;
    this.status = this.data.status;
    this.textDescription = this.data.textDescription;
    this.textIndication = this.data.textIndication;
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  onYesClick() {
    this.dialogRef.close(true);
  }
}
